import React, { useEffect, useState } from 'react';
import FormModal from '../Modals/FormModal';
import SelectField from '../Forms/Input/SelectField';
import FileUploader from '../Uploader/FileUploader';
import clsx from 'clsx';
import { CertificateFileType } from '../../types/certificate/certificate';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (file: File, fileType: CertificateFileType) => void;
  initialType: CertificateFileType | null;
  isSubmitting: boolean;
}

const TaxpayerCertificateEditModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  initialType,
  isSubmitting,
}) => {
  const [file, setFile] = useState<File | null>(null);

  // Limpiar archivo al abrir modal
  useEffect(() => {
    if (isOpen) {
      setFile(null);
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!initialType || !file) return;
    onSubmit(file, initialType);
  };

  // ✅ Generar título dinámico según el tipo de archivo
  const getTitle = () => {
    switch (initialType) {
      case 'CERTIFICATE':
        return 'Actualizar Certificado';
      case 'PRIVATE_KEY':
        return 'Actualizar Clave Privada';
      case 'PUBLIC_KEY':
        return 'Actualizar Clave Pública';
      default:
        return 'Actualizar Archivo';
    }
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={getTitle()}
      maxWidth="max-w-xl"
    >
      <form onSubmit={handleSubmit} className="mt-4 grid grid-cols-1 gap-6">
        <SelectField
          label="Tipo de Archivo"
          name="fileType"
          value={initialType || ''}
          onChange={() => {}} // Bloqueado en edición
          options={[
            { label: 'Certificado', value: 'CERTIFICATE' },
            { label: 'Clave privada', value: 'PRIVATE_KEY' },
            { label: 'Clave pública', value: 'PUBLIC_KEY' },
          ]}
          disabled={true} // No se permite cambiar el tipo en edición
          iconKey="list"
        />

        <FileUploader
          currentFile={file}
          onFileChange={setFile}
          onRemoveFile={() => setFile(null)}
          label="Seleccione nuevo archivo"
          accept=".crt,.key,.pem"
          iconKey="upload"
        />

        <button
          type="submit"
          disabled={isSubmitting}
          className={clsx(
            'w-full rounded px-4.5 py-2.5 font-medium text-white',
            isSubmitting
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-primary hover:bg-opacity-90'
          )}
        >
          {isSubmitting ? 'Actualizando...' : 'Actualizar Archivo'}
        </button>
      </form>
    </FormModal>
  );
};

export default TaxpayerCertificateEditModal;
